import React from "react";
import AnimatedModal from "./AnimatedModal";

export default function ConfirmationModal({ isOpen, onClose, onConfirm, title, message, confirmText = "Delete", cancelText = "Cancel" }) {
  return (
    <AnimatedModal isOpen={isOpen} onClose={onClose} className="max-w-md w-full">
      <div className="bg-white dark:bg-gray-900 rounded-2xl px-8 py-8 text-left overflow-hidden shadow-2xl border border-gray-200 dark:border-gray-700">
        <div className="text-center mb-6">
          <div className="flex items-center justify-center gap-2 mb-2">
            <svg className="w-7 h-7 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M21 12c0 4.418-4.03 8-9 8s-9-3.582-9-8 4.03-8 9-8 9 3.582 9 8z" />
            </svg>
            <span className="text-2xl font-bold text-gray-900 dark:text-white">{title}</span>
          </div>
        </div>
        <div className="mb-8">
          <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-center text-lg">
            {message}
          </p>
        </div>
        <div className="flex gap-4 justify-center">
          <button
            onClick={onClose}
            className="px-6 py-3 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg font-medium transition-all duration-200 border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 dark:focus:ring-gray-600"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="px-6 py-3 bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white rounded-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-400 dark:focus:ring-pink-600"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </AnimatedModal>
  );
}
